import { render, staticRenderFns } from "./UploadGlobalDialog.vue?vue&type=template&id=37118cc8"
import script from "./UploadGlobalDialog.vue?vue&type=script&lang=js"
export * from "./UploadGlobalDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports